import type { TunaEditor } from '@tunasong/plugin-lib'
import { getHTMLElementAtPath } from './html-element-at-path.js'

export const getCurrentHTMLElement = (editor: TunaEditor) => getHTMLElementAtPath(editor, editor.selection?.focus.path)
